<template>
    <div>
        <TitleCard style="max-width: 97%; margin: 10px auto" title="财务管理">
            <template v-slot:subTitle>
                <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
                    <li class="breadcrumb-item text-muted">FinancialManagement</li>
                </ul>
            </template>
        </TitleCard>
        <div class="container my-6" style="min-height: 100vh">
            <div class="row g-5 g-xl-10 mb-xl-10">
                <div class="g-5 g-xl-10">
                    <div class="card card-flush mb-xl-10" style="display: flex; justify-content: space-around">
                        <!--begin::Header-->
                        <div class="card-header pt-4">
                            <!--begin::Title-->
                            <div class="card-title d-flex flex-column">
                                <div style="display: flex; align-items: center; padding: 20px 0">
                                    <div>
                                        <div style="color: #c0c0bf">可提现金额</div>
                                        <div style="font-weight: bold; color: #ff7f5f; font-size: 24px; margin: 4px 0">&yen;{{ sellPrice.payment }}</div>
                                    </div>

                                    <div style="margin-left: 40px">
                                        <div style="color: #c0c0bf">冻结金额</div>
                                        <div style="font-weight: bold; font-size: 24px; margin: 4px 0">&yen;{{ sellPrice.frozen }}</div>
                                    </div>
                                    <el-button size="small" type="primary" style="margin-left: 100px" @click="openSettableOrders">提现</el-button>
                                </div>
                            </div>
                            <!--end::Title-->
                        </div>

                        <!--end::Header-->

                        <!--begin::Card body-->
                        <div class="d-flex flex-column justify-content-end pe-0">
                            <div ref="chartContainer" style="width: 100%; height: 100%"></div>
                        </div>
                        <!--end::Card body-->
                    </div>
                </div>
            </div>
        </div>
        <!--        withdrawVisible-->
        <el-dialog title="可提现订单" :visible.sync="withdrawVisible" width="80%">
            <div style="font-size: 20px; font-weight: bold">基础信息</div>
            <div style="display: flex; align-items: center; margin-bottom: 20px">
                <div>公司名称:</div>
                <el-input placeholder="请输入公司名称" v-model="userInfo.companyName" style="width: 30%" size="small" :disabled="true"></el-input>
                <el-button type="primary" v-if="cardIdDisable" @click="cardIdDisable = false" size="small" style="margin-left: 20px">修改</el-button>
                <el-button type="success" v-if="!cardIdDisable" @click="saveStaffBank" size="small" style="margin-left: 20px">保存</el-button>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 20px">
                <div>开户银行:</div>
                <el-input placeholder="请输入开户行" v-model="userInfo.bankName" style="width: 30%" size="small" :disabled="cardIdDisable"></el-input>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 20px">
                <div>银行卡号:</div>
                <el-input placeholder="请输入银行卡号" v-model="userInfo.cardId" style="width: 30%" size="small" :disabled="cardIdDisable"></el-input>
            </div>
            <div style="font-size: 20px; font-weight: bold; margin-top: 40px">提现订单</div>
            <el-table ref="settableTable" :data="listSettable" row-key="orderNo" border @selection-change="handleSelectionChange" style="">
                <el-table-column type="selection" reserve-selected-cross-page width="55"></el-table-column>
                <el-table-column prop="orderNo" label="订单号"></el-table-column>
                <el-table-column prop="disPrice" label="结算价"></el-table-column>
                <el-table-column prop="crTime" label="创建时间"></el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChangeSettable"
                @current-change="handleCurrentChangeSettable"
                :current-page="paramsSettable.current"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="paramsSettable.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSettable"
            ></el-pagination>

            <div style="font-size: 20px; font-weight: bold; margin-top: 20px">发票提交</div>
            <div>请上传发票PDF文件</div>
            <el-upload class="avatar-uploader" accept="application/pdf" action="#" ref="uploadImage" :http-request="uploadImg" :multiple="false" :file-list="fileList" :on-change="imgSaveToUrl" :before-upload="beforeAvatarUpload" :show-file-list="false">
                <img v-if="invoiceImgFullUrl" src="https://xysy-saas.oss-cn-hangzhou.aliyuncs.com/lianXiangHui/pdf.png" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>

            <div style="margin-top: 20px; display: flex; justify-content: flex-end">
                <el-popconfirm confirm-button-text="确认" cancel-button-text="去修改" icon="el-icon-info" icon-color="red" title="请确认您提现的银行卡号是否正确" @confirm="submitOrder">
                    <el-button type="primary" size="small" slot="reference">提交</el-button>
                </el-popconfirm>
            </div>
        </el-dialog>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// 例如：import uploadFile from '@/components/uploadFile/uploadFile'

import { wxUserCountTodayFansApi, wxUserGetFansApi, wxUserMyAccountFansApi } from "@/api/WxUserApi";
import { getSellPriceApi, getSettableApi } from "@/api/orderApi";
import { addWithdrawalPassOrRejectApi } from "@/api/WithdrawalApplicationApi";
import { saveBankCardApi, uploadBankApi, uploadFileApi } from "@/api/uploadFileApi";
import { getMyInfoApi } from "@/api/userApi";

export default {
    name: "index",
    // import引入的组件需要注入到对象中才能使用
    components: {},
    props: {
        // patientIn: {
        //   type: Object,
        //   default () {
        //     return {}
        //   }
        // }
    },
    data() {
        // 这里存放数据
        return {
            withdrawVisible: false,
            dialogVisible: false,
            params: {
                current: 1,
                size: 10,
            },
            fansList: [],
            totalFans: 0,
            todayFans: 0,
            balance: 0,
            issued: 0,
            sellPrice: {
                payment: 0,
                frozen: 0,
            },
            paramsSettable: {
                current: 1,
                size: 10,
            },
            totalSettable: 0,
            listSettable: [],
            userInfo: {
                cardId: "",
                companyName: "",
                bankName: "",
            },
            cardIdDisable: true,
            submitOrderList: [],
            selectedOrderNos: [],
            selectedOrdersMap: new Map(),
            file: null,
            fileList: [],
            invoiceImgFullUrl: false,
        };
    },
    // 监听属性 类似于data概念
    computed: {},
    // 方法集合
    methods: {
        getMyInfo() {
            getMyInfoApi().then((res) => {
                console.log(res);
                if (res.code == 200) {
                    this.userInfo.cardId = res.data.bankCard;
                    this.userInfo.bankName = res.data.bankName;
                    this.userInfo.companyName = res.data.companyName;
                }
            });
        },
        handleSelectionChange(val) {
            this.submitOrderList = val.map((item) => item.orderNo);
            val.forEach((item) => {
                this.selectedOrdersMap.set(item.orderNo, item);
            });
        },
        openSettableOrders() {
            /*      if (this.$store.getters.userInfo.canWithdrawal == false){
                    this.$confirm("您还未完成实名认证，请在小程序使用店长账号进行实名认证","提示",{
                      confirmButtonText: '确认',
                      showCancelButton: false
                    })
                    return
                  }*/
            if (this.sellPrice.pendingWithdrawal == 0) {
                this.$message.error({
                    message: "您没有可提现的订单",
                });
                return;
            }
            this.paramsSettable = {
                current: 1,
                size: 10,
            };
            this.selectedOrdersMap.clear();
            this.submitOrderList = [];
            this.getSettable();
            this.file = "";
            this.cardId = this.$store.getters.userInfo.cardId;
            this.withdrawVisible = true;
            this.$nextTick(() => {
                this.$refs.settableTable.clearSelection();
            });
            this.getMyInfo();
        },
        async getSettable() {
            let { data } = await getSettableApi(this.paramsSettable);
            this.listSettable = data.rows;
            this.totalSettable = data.total;
            this.$nextTick(() => {
                this.restoreSelection();
            });
        },
        restoreSelection() {
            this.listSettable.forEach((item) => {
                if (this.selectedOrdersMap.has(item.orderNo)) {
                    this.$refs.settableTable.toggleRowSelection(item, true);
                }
            });
        },
        handleSizeChangeSettable(val) {
            this.paramsSettable.size = val;
            this.getSettable();
        },
        handleCurrentChangeSettable(val) {
            this.paramsSettable.current = val;
            this.getSettable();
        },
        handleSizeChange(val) {
            this.params.size = val;
            this.wxUserGetFans();
        },
        handleCurrentChange(val) {
            this.params.current = val;
            this.wxUserGetFans();
        },
        toCheckBalance() {
            this.$message.info("收益明细请在小程序个人中心进行查看");
        },
        async wxUserGetFans() {
            let { data } = await wxUserGetFansApi();
            this.fansList = data.rows;
            this.totalFans = data.total;
        },
        async wxUserCountTodayFans() {
            let { data } = await wxUserCountTodayFansApi();
            if (data) {
                this.totalFans = data;
            }
        },
        async wxUserMyAccountFans() {
            let { data } = await wxUserMyAccountFansApi();
            this.balance = data.balance;
            this.issued = data.issued;
        },
        async getSellPrice() {
            let { data } = await getSellPriceApi();
            this.sellPrice = data;
        },

        async submitOrder() {
            const allSelectedOrderNos = Array.from(this.selectedOrdersMap.keys());
            console.log(this.userInfo);
            if (!this.cardIdDisable) {
                await this.saveStaffBank();
            }
            if (allSelectedOrderNos.length <= 0) {
                this.$message.error("请选择订单");
                return;
            }
            if (this.userInfo.cardId == "") {
                this.$message.error("请填写银行卡号");
                return;
            }
            if (this.userInfo.bankName == "") {
                this.$message.error("请填写开户银行");
                return;
            }
            if (this.file == "") {
                this.$message.error("请上传发票");
                return;
            }
            const res = await addWithdrawalPassOrRejectApi({
                orderNos: allSelectedOrderNos,
                cardId: this.userInfo.cardId,
                bankName: this.userInfo.bankName,
                invoiceUrl: this.file,
            });
            if (res.code == 200) {
                this.$message.success("提现申请成功");
                setTimeout(async () => {
                    await this.getSellPrice();
                    this.withdrawVisible = false;
                    this.file = "";
                }, 300);
            }
        },
        async saveStaffBank() {
            const res = await saveBankCardApi({
                cardId: this.userInfo.cardId,
                bankName: this.userInfo.bankName,
            });
            console.log(res, "我咋这");
            if (res.code == 200) {
                this.$message.success("保存成功");
                this.cardIdDisable = true;
            } else {
                this.$message.error(res.msg);
            }
        },
        async uploadImg(param) {
            const data = new FormData();
            data.append("file", param.file);
            data.append("moduleName", "finance/rechargeRecords");
            let { data: res } = await uploadFileApi(data);
            this.file = res.fileUrl;
        },
        imgSaveToUrl(event) {
            this.invoiceImgFullUrl = true;
        },
        beforeAvatarUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 2MB!");
            }
            return isLt2M;
        },
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getSellPrice();
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {},
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {}, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    text-align: center;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px !important;
    text-align: center;
}
</style>
